import {SHARE_BASE_URL} from "../settings";

export const REFRESH_TIME_LONG = 5 * 60 * 1000; // 5 minutes
export const REFRESH_TIME_SHORT = 20 * 1000; // 20 seconds

export const isinUrl = (path?: string, isin?: string) =>
  isin && path ? `${SHARE_BASE_URL}${isin}/${path}` : null;

export type Trade = {
  unixtime: number;
  isoTimestamp: string;
  price: number;
  volume: number;
  value: number;
};

export type TradeResponse = {
  isin: string;
  trades: Array<Trade>;
};

type GraphItem = {
  price: string;
  unixTimestamp: number;
  volume: string;
};

export type GraphResponse = {
  isin: string;
  data: Array<GraphItem>;
};

export type DailyData = {
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
};

export enum Period {
  D1 = "D1",
  M5 = "M5",
  Y1 = "Y1",
}

export type OHLCV = {
  open: number | null;
  high: number | null;
  low: number | null;
  close: number | null;
  volume: number | null;
};

export type DailyResponse = {
  isin: string;
  day: DailyData;
};

export type PricePeriod = OHLCV & {
  period: Period | null;
  isoTimestamp: string | null;
  unixTimestamp: number | null;
};

export enum Direction {
  UP = "up",
  DOWN = "down",
}

export type CurrentPriceResponse = {
  isin: string;
  day: OHLCV;
  current: PricePeriod;
  last: PricePeriod;
  year: PricePeriod;
  change: {
    amount: number;
    direction: Direction | "";
    pct: string;
  };
  sharesInIssue: number | null;
  marketCap: number | null;
};

export const CATEGORY_LIST = {
  "category-acquisitions-alliances": "Acquisitions and alliances",
  "category-meetings": "AGMs and other meetings",
  "category-board-changes": "Board changes",
  "category-capital-structure": "Capital structure",
  "category-corporate-updates": "Corporate updates",
  "category-director-pdmr-dealings": "Director/PDMR dealings",
  "category-disposals": "Disposals",
  "category-holdings": "Holding(s) in company",
  "category-results": "Results",
  "category-trading-updates": "Trading updates",
  "category-misc": "Miscellaneous"
};

export const fetcher = (url) => fetch(url).then((res) => res.json());

export const timeFetcher = async (url) => {
  const res = await fetch(url);
  return {
    ...(await res.json()),
    fetched: new Date(),
  };
};
